import React, { useEffect, useState } from 'react'
import { useStateValue } from '../StateProvider';
import { BuildTalents, getDate, getDefaultName, getDefaultValue } from '../utils';
import { loadFaqs, loadMenuTalents, loadPosts, loadVideoGalleries } from '../utils/Network';
import parse from 'html-react-parser'
import ShowVideoModal from '../components/dialogs/ShowVideoModal';

export default function FaqsContent({ id, embedded = false }) {

    const [loading, setLoading] = useState(false);
    const [faqs, setFaqs] = useState(null);
    const [active, setActive] = useState(null);
    const [show_video_is_open, setShowVideoIsOpen] = useState(false);
    const [video, setVideo] = useState(false);
    const [videos, setVideos] = useState(null)


    useEffect(() => {
        setLoading(true)
        if (!embedded) {
            document.title = 'KurdishTalent | Frequently asked questions '
        }

        loadFaqs().then(faqs => {
            setFaqs(faqs)
            setLoading(false)
        })


        loadVideoGalleries("help").then(videos => {
            setVideos(videos);
        });
        setLoading(false)

    }, [embedded])


    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x => x.key == str);

        if (translate) return getDefaultValue(translate);
        else return str;
    };

    const faqQuestion = (item) =>
        item.names?.length ? getDefaultName(item.names, "question") : item.question;
    const faqAnswerHtml = (item) =>
        item.names?.length ? getDefaultName(item.names, "answer") : item.answer;


    const inner = (
        <>
            <div className={embedded ? "container-fluid px-0" : "container "}>
                {loading &&
                    <>
                        <div className="bounce-loader">
                            <div className="bounce1"></div>
                            <div className="bounce2"></div>
                            <div className="bounce3"></div>
                        </div>
                    </>
                }

                {!loading &&

                    <div className={`${embedded ? "container-fluid px-0 pb-3 pt-0" : "container pb-4 mt-header"}`}>
                        {!embedded && (
                        <div className="overflow-hidden">
                            <h2 className=" font-weight-bold text-10 mb-2 pt-0 mt-0 appear-animation animated maskUp appear-animation-visible" data-appear-animation="maskUp" data-appear-animation-delay="300" style={{ animationDelay: "300ms" }}>
                                {translate("FAQ")}
                            </h2>
                        </div>
                        )}
                        <div className="row">
                            <div className="col-lg-3 order-lg-1">
                                <aside className="sidebar">
                                    <ul className="simple-post-list">
                                        {videos && videos.map(item => (
                                            <li key={item.id} className="lan-rtl">
                                                <div className="post-info lan-rtl lan-text-right " onClick={(e) => { e.preventDefault(); setVideo(item); setShowVideoIsOpen(true) }}>
                                                    <a href="#" className="lan-text-right  kfont" title={ item.names && getDefaultName(item.names) || item.title }>
                                                        <div className="mb-2 vd-container">
                                                            <video width="100%" height="150" poster={item.image} >
                                                                <source src={item.file} type="video/mp4" />
                                                            </video>
                                                            <span className="infoicon">
                                                                <i className="fa fa-play"></i>
                                                            </span>
                                                        </div>
                                                    </a>


                                                </div>


                                            </li>
                                        ))}
                                    </ul>
                                </aside>
                            </div>
                            <div className="col-lg-9">

                                <div className="toggle toggle-primary m-0" data-plugin-toggle>


                                    {faqs?.map((item) => (
                                        <section key={item.id} onClick={() => { if (item.id != active) setActive(item.id); else setActive(0); }} className={`toggle ${active == item.id ? "active" : ""}`}>
                                            <a className="toggle-title kfont lan-rtl lan-text-right">{faqQuestion(item)}</a>
                                            <div className="toggle-content ">
                                                <p className="kfont lan-rtl lan-text-right">{parse(faqAnswerHtml(item) || "")}</p>
                                            </div>
                                        </section>
                                    ))}


                                </div>

                            </div>

                        </div>


                    </div>


                }


            </div>
            <ShowVideoModal key={video?.id} isOpen={show_video_is_open} url={video?.file} poster={video?.image} setIsOpen={setShowVideoIsOpen} />
        </>
    )

    if (embedded) {
        return (
            <div className="participant-support-faq-embed lan-kfont lan-text-right lan-rtl" role="tabpanel" id="support-tabpanel-faq" aria-labelledby="support-tab-faq">
                {inner}
            </div>
        )
    }

    return (
        <div id="main" role="main" className="main bg-blog">

            <section className="page-header pb-0 page-header-modern page-header-lg mb-0 pb-4  page-header-background   overlay-op-7 ">
            </section>

            {inner}
        </div>
    )

}
